<a class="open-social-btn" (click)="openModal()" [ngClass]="customClass" title="Share this content!">
    <svg version="1.1" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" class="ng-element interactive" data-id="1e33b67df6f3dd7fcec3e41978a590be" style="fill: rgb(173, 58, 58); width: 26px; height: 26px; filter: none;" xmlns="http://www.w3.org/2000/svg"><g><defs> </defs> <rect display="none" fill="#FFA400" width="24" height="24" style="fill: rgb(173, 58, 58);"/> <rect id="_x3C_Slice_x3E__109_" display="none" fill="none" width="24" height="24" style="fill: rgb(173, 58, 58);"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M20,16c-1.365,0-2.567,0.686-3.289,1.729l-8.864-4.692C7.937,12.704,8,12.361,8,12 s-0.063-0.704-0.153-1.037l8.864-4.692C17.433,7.313,18.635,8,20,8c2.209,0,4-1.791,4-4s-1.791-4-4-4c-2.209,0-4,1.791-4,4 c0,0.038,0.01,0.074,0.011,0.111L6.682,9.051C5.972,8.404,5.036,8,4,8c-2.209,0-4,1.791-4,4s1.791,4,4,4 c1.036,0,1.971-0.404,2.682-1.051l9.329,4.939C16.01,19.927,16,19.962,16,20c0,2.209,1.791,4,4,4c2.209,0,4-1.791,4-4 S22.209,16,20,16z M20,2c1.104,0,2,0.896,2,2s-0.896,2-2,2s-2-0.896-2-2S18.896,2,20,2z M4,14c-1.104,0-2-0.896-2-2s0.896-2,2-2 s2,0.896,2,2S5.104,14,4,14z M20,22c-1.104,0-2-0.896-2-2s0.896-2,2-2s2,0.896,2,2S21.104,22,20,22z" style="fill: rgb(173, 58, 58);"/> </g></svg>
</a>

<ng-template #socialSharingModal let-c="close" let-d="dismiss">
    <img (click)="d('Cross click')" class="ng-element modal-cross" [src]="'/assets/svg/modal-cross.svg'"/>
    <div class="social-icons">
        <a href="{{setSocialLink(social)}}" target="_blank" *ngFor="let social of socialItems">
          <fa-icon [icon]="['fab', social]" ></fa-icon>
        </a>
    </div>

    <h4>Link</h4>
    <div class="input-group link">
        <span class="input-group-label">
          <fa-icon [icon]="['fas', 'link']" ></fa-icon>
        </span>
        <input [(ngModel)]="link" class="form-control" type="text"/>
        <button
                type="button"
                ngxClipboard
                [cbContent]="link"
                (cbOnSuccess)="linkCopied = true"
                class="input-group-button button primary">
            {{ linkCopied ? 'Copied' : 'Copy' }}
        </button>
    </div>

    <!--<h4 class="embed-title">Embed</h4>-->
    <!--<div class="form-group mb-6">-->
        <!--<textarea class="form-control" rows="5" [(ngModel)]="embedText" type="text"></textarea>-->
    <!--</div>-->
    <!--<div class="form-group text-right embed">-->
        <!--<button-->
                <!--type="button"-->
                <!--ngxClipboard-->
                <!--[cbContent]="embedText"-->
                <!--(cbOnSuccess)="embedTextCopied = true"-->
                <!--class="input-group-button button primary">-->
            <!--{{ embedTextCopied ? 'Copied' : 'Copy' }}-->
        <!--</button>-->
    <!--</div>-->

</ng-template>
